// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__3nkh2","list":"FieldCheckboxGroup_list__3LZWV","twoColumns":"FieldCheckboxGroup_twoColumns__1GJDH","item":"FieldCheckboxGroup_item__1DYu3"};